module.exports = __webpack_public_path__ + "static/media/Munchlax_gaussian2.6e21a284.png";